import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, MapPin } from "lucide-react";
import { api, fdate } from "@/lib/api";
import { PageHeader, StatusBadge, Empty } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";

export default function Interventions() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/interventions").then((r) => setItems(r.data)); }, []);

  return (
    <div>
      <PageHeader kicker="Suivi opérationnel" title="Interventions & projets">
        <Button className="bg-red-600 hover:bg-red-700" data-testid="new-intervention-btn" onClick={() => navigate("/interventions/nouvelle")}>
          <Plus className="mr-1 h-4 w-4" /> Nouvelle intervention
        </Button>
      </PageHeader>
      <p className="mb-6 max-w-2xl text-sm text-slate-500">
        Le rapport est généré automatiquement à chaque enregistrement. Lorsqu'une intervention passe au statut « Terminée », son bilan est archivé et devient consultable par la direction.
      </p>
      {items.length ? (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {items.map((i, k) => (
            <button
              key={i.id}
              onClick={() => navigate(`/interventions/${i.id}`)}
              data-testid={`intervention-card-${i.number}`}
              style={{ animationDelay: `${k * 40}ms` }}
              className="fade-up rounded-md border border-slate-200 bg-white p-5 text-left transition-transform duration-200 hover:-translate-y-0.5 hover:border-slate-300"
            >
              <div className="flex items-start justify-between gap-2">
                <span className="font-mono text-xs text-slate-500">{i.number}</span>
                <StatusBadge status={i.status} />
              </div>
              <h3 className="mt-3 font-display text-lg font-semibold text-slate-900">{i.title}</h3>
              <p className="mt-1 text-sm text-slate-600">{i.client_name}</p>
              <p className="mt-2 flex items-center gap-1 text-xs text-slate-500"><MapPin className="h-3 w-3" /> {i.site} · {fdate(i.start_date)}</p>
              <div className="mt-4 flex items-center gap-3">
                <Progress value={i.progress} className="h-1.5" />
                <span className="font-mono text-xs">{i.progress}%</span>
              </div>
            </button>
          ))}
        </div>
      ) : <Empty testId="interventions-empty" text="Aucune intervention active." />}
    </div>
  );
}
